import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { cashService } from '../../services/cashService';

export const useGetNextRepayment = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.cash.next_repayment],
    refetchOnWindowFocus: false,
    queryFn: () =>
      cashService.nextRepayment().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
